var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressivegame({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_703_591)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99986 0C6.44943 0 3.57129 2.87817 3.57129 6.42857C3.57129 9.979 6.44943 12.8571 9.99986 12.8571C13.5503 12.8571 16.4284 9.979 16.4284 6.42857C16.4284 2.87817 13.5503 0 9.99986 0ZM9.99986 2.5C10.3944 2.5 10.7141 2.8198 10.7141 3.21429V6.08529L12.2318 7.29936C12.5399 7.54579 12.5898 7.99528 12.3434 8.30336C12.0969 8.61143 11.6474 8.66136 11.3394 8.41493L9.55365 6.98636C9.38422 6.85079 9.28557 6.64557 9.28557 6.42857V3.21429C9.28557 2.8198 9.60536 2.5 9.99986 2.5Z",
    fill: "#6B758B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85714 14.2856C1.27919 14.2856 0 15.5649 0 17.1428C0 18.7207 1.27919 19.9999 2.85714 19.9999H17.1429C18.7208 19.9999 20 18.7207 20 17.1428C20 15.5649 18.7208 14.2856 17.1429 14.2856H2.85714ZM2.14286 17.1428C2.14286 16.7483 2.46266 16.4285 2.85714 16.4285H7.14286C7.53736 16.4285 7.85714 16.7483 7.85714 17.1428C7.85714 17.5373 7.53736 17.8571 7.14286 17.8571H2.85714C2.46266 17.8571 2.14286 17.5373 2.14286 17.1428Z",
    fill: "#6B758B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_703_591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressivegame);
export default __webpack_public_path__ + "static/media/Progressive game.2e77f9b4e7b6b45bf5da8c253e3ca0a0.svg";
export { ForwardRef as ReactComponent };